import { compose, onlyUpdateForKeys, withHandlers } from 'recompose';
import withLifecycle from '@hocs/with-lifecycle';
import { ApiClient } from 'services';

const enhance = compose(
  onlyUpdateForKeys(['path', 'refreshToken']),
  withHandlers({
    fetch: ({
      url,
      filters,
      onDataFetched,
      filterType = null,
      filterValue = null,
    }) => () => {
      const client = ApiClient();
      client.get(url).then(({ data }) => {
        onDataFetched(data);
      });
    },
  }),
  withLifecycle({
    onDidMount: ({ fetch }) => fetch(),
    onWillUpdate: ({ fetch }) => fetch(),
  })
);

export const DataFetch = () => null;

export default enhance(DataFetch);



// WEBPACK FOOTER //
// ./src/components/common/DataFetch.js